module.exports = __webpack_public_path__ + "static/chorus-3-7779a361796ae445fb876848d1562bf5.jpg";